import { MessageCircle } from "lucide-react";
import { ORG } from "../data/siteData";

export const WhatsAppFloat = () => (
  <a
    href={`https://wa.me/${ORG.whatsapp}?text=${encodeURIComponent("Olá! Vim pelo site da AMACLI e gostaria de mais informações.")}`}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-button"
    aria-label="Falar no WhatsApp"
    className="fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full bg-[#25D366] hover:bg-[#1fb857] text-white flex items-center justify-center shadow-lg shadow-black/40 transition-colors duration-200"
  >
    <MessageCircle className="h-7 w-7" />
  </a>
);
